/**
 * ARK-2099: автоматическая инициализация intl-tel-input на телефонных полях.
 * Применяется к input[type="tel"] и input[name="phone"].
 *
 * Перед submit формы:
 *  - значение input заменяется на E.164 формат (для unique-проверок и единого хранения)
 *  - в форму добавляется hidden input "<имя>_country" с iso2 кодом страны
 */
(function () {
    'use strict';

    if (typeof window.intlTelInput === 'undefined') {
        return;
    }

    const DEFAULTS = {
        initialCountry: 'it',
        countryOrder: ['it', 'fr', 'de', 'es', 'ch', 'at', 'gb', 'nl', 'be'],
        separateDialCode: true,
        autoPlaceholder: 'off',
        countrySearch: true
    };

    function initPhoneInput(input) {
        if (!input || input._iti || input.dataset.itiInit === '1') return;
        input.dataset.itiInit = '1';

        // Если есть hidden поле <name>_country — используем его как initialCountry
        const fieldName = input.name || 'phone';
        const form = input.form;
        const countryHidden = form ? form.querySelector('[name="' + fieldName + '_country"]') : null;
        const initialCountry = (countryHidden && countryHidden.value) || DEFAULTS.initialCountry;

        const iti = window.intlTelInput(input, Object.assign({}, DEFAULTS, {
            initialCountry: initialCountry
        }));
        input._iti = iti;

        // DEV-994: если инпут управляется Alpine (x-model), НЕ вешаем submit-хук, который
        // переписывает input.value на E.164. Иначе при separateDialCode «+код» попадает внутрь
        // инпута и intl-tel-input дублирует код страны при возврате на шаг назад.
        // Alpine-флоу (register-wizard) сам читает iti.getNumber() и шлёт E.164 (см. wizard.js).
        const isAlpineManaged = input.hasAttribute('x-model') || input.hasAttribute('x-ref');

        if (form && !isAlpineManaged) {
            // На submit — проставляем E.164 в input + создаём/обновляем hidden с iso2
            form.addEventListener('submit', function () {
                if (typeof iti.getNumber === 'function') {
                    const e164 = iti.getNumber();
                    if (e164) {
                        input.value = e164;
                    }
                }
                const country = iti.getSelectedCountryData ? iti.getSelectedCountryData().iso2 : null;
                if (country) {
                    const hiddenName = fieldName + '_country';
                    let hidden = form.querySelector('input[type="hidden"][name="' + hiddenName + '"]');
                    if (!hidden) {
                        hidden = document.createElement('input');
                        hidden.type = 'hidden';
                        hidden.name = hiddenName;
                        form.appendChild(hidden);
                    }
                    hidden.value = country;
                }
            }, true);
        }
    }

    function initAll(root) {
        const scope = (root && root.querySelectorAll) ? root : document;
        scope.querySelectorAll('input[type="tel"], input[name="phone"]').forEach(initPhoneInput);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { initAll(document); });
    } else {
        initAll(document);
    }

    // MutationObserver для динамически добавленных инпутов
    if (typeof MutationObserver !== 'undefined') {
        new MutationObserver(function (mutations) {
            mutations.forEach(function (m) {
                m.addedNodes.forEach(function (node) {
                    if (node.nodeType !== 1) return;
                    if (node.matches && (node.matches('input[type="tel"]') || node.matches('input[name="phone"]'))) {
                        initPhoneInput(node);
                    } else if (node.querySelectorAll) {
                        initAll(node);
                    }
                });
            });
        }).observe(document.body, { childList: true, subtree: true });
    }

    window.initPhoneInputs = initAll;
})();
